module.exports = __webpack_public_path__ + "media/packs/images/details/containers-ef5e2ffbd15fa0a3a984861ab895cff8.svg";